export class AnimationFrame {

    constructor () {

        this.isStop = true;
        this.playing = false;

        this.then = 0;
        this.startTime = 0;

        this.elapsed = 0;
        this.fps = 30;
        this.fpsInterval = 1000 / 30;

        this.frameRate = 0;
        this.frameCount = 0;
        this.callback = null;

        const vendors = [ 'webkit', 'moz' ];
        let lastTime = 0;

        for ( let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x ) {
            window.requestAnimationFrame = window[ vendors[ x ] + 'RequestAnimationFrame' ];
            window.cancelAnimationFrame =
                window[ vendors[ x ] + 'CancelAnimationFrame' ] || window[ vendors[ x ] + 'CancelRequestAnimationFrame' ];
        }

        if ( !window.requestAnimationFrame )

            window.requestAnimationFrame = ( callback ) => {

                const currTime = performance.now();
                const timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );
                const id = window.setTimeout( () => callback( currTime + timeToCall ), timeToCall );

                lastTime = currTime + timeToCall;
                return id;
            };

        if ( !window.cancelAnimationFrame )
            window.cancelAnimationFrame = ( id ) => {
                clearTimeout( id );
            };

    }

    start ( _fps, _callback ) {

        this.then = performance.now();
        this.startTime = this.then;

        this.isStop = false;
        this.playing = true;

        this.callback = _callback;
        this.set_fps( _fps );
        this.tick();
    }

    stop () {

        this.isStop = true;
        window.cancelAnimationFrame( this.id );

    }

    tick () {

        const scope = this;

        if ( this.isStop ) {

            this.playing = false;
            return;

        }

        const now = performance.now();
        this.elapsed = now - this.then;

        if ( this.elapsed > this.fpsInterval ) {

            this.then = now - ( this.elapsed % this.fpsInterval );
            this.callback();

            const sinceStart = now - this.startTime;
            this.frameRate = Math.round( 1000 / ( sinceStart / ++this.frameCount ) * 100 ) / 100;

        }

        this.id = window.requestAnimationFrame( function () {
            scope.tick();
        } );
    }

    get_isStop () {

        return this.isStop;

    }

    set_fps ( _fps ) {

        this.fps = _fps;
        this.fpsInterval = 1000 / this.fps;

    }

    get_fps () {

        return this.frameRate;

    }

}